module.exports = __webpack_public_path__ + "img/Station Location Map.ff3be0b5.jpg";